export const processRequest = (request) => {
    const {
        bankAccount = '',
        bankReference = '',
        paymentMethod = '',
        specialHandling = '',
        boletoNumber = '',
        guiaNumberBarcode = '',
        guiaNumberNoCode = '',
        italyF24 = '',
        italyMav = '',
        dinNumber = '',
        lineaDeCaptura = '',
        isr = '',
        bankDetails = '',
        pagoReferenciado = '',
        taxType = '',
        modelo = '',
        rfc = '',
        ...rest
    } = { ...request.additionalInfo };
    const requestDetail = {
        requestInformation: {
            requestType: request.requestType || null,
            category: request.category || null,
            subCategory: request.subCategory || null,
            isFastTrack: request.isFastTrack || null,
            title: request.title || null,
            businessReason: request.businessReason || null,
        },
        accountingDetails: {
            vendor: request.vendor || '',
            vendorName: request.vendorName || '',
            companyCode: request.companyCode || '',
            requestDate: request.requestDate || '',
            dueDate: request.dueDate || '',
            postingDate: request.postingDate || '',
            taxCode: request.taxCode || '',
            documentType: request.documentType || '',
            amount: request.amount || '',
            currency: request.currency || '',
            invoiceReference: request.invoiceReference || '',
        },

        paymentInformation: {
            bankAccount: bankAccount || { value: '' },
            bankReference: bankReference || { value: '' },
            paymentMethod: paymentMethod || { value: '' },
            specialHandling: specialHandling || { value: '' },
            boletoNumber: boletoNumber || { value: '' },
            guiaNumberBarcode: guiaNumberBarcode || { value: '' },
            guiaNumberNoCode: guiaNumberNoCode || { value: '' },
            italyF24: italyF24 || { value: '' },
            italyMav: italyMav || { value: '' },
            dinNumber: dinNumber || { value: '' },
            lineaDeCaptura: lineaDeCaptura || { value: '' },
            rfc: rfc || { value: '' },
            modelo: modelo || { value: '' },
            isr: isr || { value: '' },
            bankDetails: bankDetails || { value: '' },
            pagoReferenciado: pagoReferenciado || { value: '' },
            taxType: taxType || { value: '' },
        },
        otherPaymentInformation: { ...rest },
        calculateTax: request.calculateTax,
        inheritTaxCode: request.inheritTaxCode || null,
    };
    return requestDetail;
};

const getGlobalKeyFromString = (value) => {
    const si_key = 'si-global-';
    return value.replace(si_key, '');
};

const getUserKeyFromString = (value, userId) => {
    const user_key = 'si' + '-' + userId + '-';
    return value.replace(user_key, '');
};

export const processValStore = (global, user, userId) => {
    const data = {};

    if (global && global.length > 0) {
        global.map((item) => {
            const key = getGlobalKeyFromString(item.key);
            data[key] = { global: item.value, recents: [] };
        });
    }

    if (user && user.length > 0) {
        user.map((item) => {
            const key = getUserKeyFromString(item.key, userId);
            if (data[key]) {
                item.value.map((userRecentItem) => {
                    const indexofItem = data[key].global.findIndex((x) => x.value === userRecentItem);
                    if (indexofItem !== -1) {
                        data[key].recents.push(data[key].global[indexofItem]);
                    } else {
                        data[key].recents.push({
                            title: userRecentItem,
                            description: userRecentItem,
                            value: userRecentItem,
                        });
                    }
                });
            } else {
                data[key] = { global: [], recents: [] };
                item.value.forEach((userRecentItem) => {
                    data[key].recents.push({
                        title: userRecentItem,
                        description: userRecentItem,
                        value: userRecentItem,
                    });
                });
            }
        });
    }

    return data;
};

export const checkDuplicateAndReturnItem = (requestedKeyVal, val) => {
    if (requestedKeyVal) {
        let keyValueData = { ...requestedKeyVal };

        let isDuplicate = false;
        const indexofItemsRecent = keyValueData.recents.findIndex((x) => x.value === val);
        if (indexofItemsRecent >= 0) {
            isDuplicate = true;
            return { isDuplicate: true, item: null };
        }
        const itemIndex = keyValueData.global.findIndex((x) => x.value === val);
        if (itemIndex >= 0) {
            const item = keyValueData.global[itemIndex];
            keyValueData.recents.push(item);
        } else {
            const item = { title: val, description: val, value: val };
            keyValueData.recents.push(item);
        }
        return { isDuplicate, item: keyValueData };
    } else {
        let keyValueData = { global: [], recents: [] };
        const item = { title: val, description: val, value: val };
        keyValueData.recents.push(item);
        // keyValueData.global.push(item);
        return { isDuplicate: false, item: keyValueData };
    }
};
